import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate } from 'react-router';

import { useVerifyCdDeliveryPayment } from '../../../../shared/hooks/caseHook';

export const MobilePaymentCdCallback = () => {
  const [params] = useSearchParams();
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mobilePaymentCallback',
  });
  const navigate = useNavigate();
  const onError = useCallback(() => {
    navigate('/images-list');
  }, [navigate]);
  const onSuccess = () => {
    navigate('/requested-images');
  };
  const { mutate: verifyPay } = useVerifyCdDeliveryPayment({
    onError,
    onSuccess,
  });
  const merchantId = params.get('merchant_uid');
  const success = params.get('imp_success');
  useEffect(() => {
    if (success === 'true' && !!merchantId?.length) {
      verifyPay(merchantId);
    } else {
      onError();
    }
  }, [merchantId, onError, success, verifyPay]);
  return <div>{t('loadingMessage')}</div>;
};
